import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { ResultsModule } from '../../results.module';
import { InlineReferenceItemComponent } from './inline-reference-item.component';

@NgModule({
  declarations: [InlineReferenceItemComponent],
  imports: [CommonModule],
  exports: [InlineReferenceItemComponent, ResultsModule],
  providers: [],
})
export class InlineReferenceItemModule {
  constructor(injector: Injector) {
    const inlineRefElement = createCustomElement(InlineReferenceItemComponent, { injector });
    customElements.define('inline-reference-item', inlineRefElement);
  }
}
